import { payment_linkService } from '../_services';
import { router } from '../_helpers';

const state = { onRequest: false, payment_links: [], payment_link: {} };

const actions = {
    get({ dispatch, commit }, id) {
        commit('request');

        payment_linkService.get(id)
            .then(
                resp => {
                    commit('success_data', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    add({ dispatch, commit }, data) {
        commit('request');

        payment_linkService.add(data)
            .then(
                async () => {
                    commit('success');
                    await router.push('/payment_links');
                    dispatch('alert/success', "Payment Link Added Successfully", { root: true });
                },
                async error => {
                    commit('error');
                    await router.push('/payment_links');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    destroy({ dispatch, commit }, id){
      commit('request');

      payment_linkService.destroy(id)
          .then(
              async () => {
                  commit('success');
                  await router.go('/payment_links');
                  dispatch('alert/success', "Payment Link Deleted Successfully", { root: true });
              },
              async error => {
                  commit('error');
                  await router.go('/payment_links');
                  dispatch('alert/error', error, { root: true });
              }
          );
    },
    get_payment_link_by_account({ dispatch, commit }, data) {
        commit('request');

        payment_linkService.get_payment_link_by_account(data)
            .then(
                (resp) => {
                    commit('success_datas', resp);
                },
                error => {
                    commit('error');
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};
const getters = {
  onRequest: state => {
    return state.onRequest
  },
  payment_links: state => {
    return state.payment_links
  },
  payment_link: state => {
    return state.payment_link
  },
};

const mutations = {
    request(state) {
        state.onRequest = true;
        state.payment_link = {};
        state.payment_links = [];
    },
    success(state) {
      state.onRequest = false;
    },
    success_data(state, data) {
      state.onRequest = false;
      state.payment_link = data;
    },
    success_datas(state, data) {
      state.onRequest = false;
      state.payment_links = data;
    },
    error(state) {
        state.onRequest = false;
    },
};

export const payment_links = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations
};
